export const surgicalBedStatusOptions: ReactSelectOption[] = [
	{ value: "0", label: "Disponível" },
	{ value: "1", label: "Indisponível" },
	{ value: "2", label: "Reservado" },
	{ value: "3", label: "Ocupado" },
];
